import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const ContactBlock = () => {
	// Animation constants matching home page
	const bounceTransition = {
		duration: 0.4,
		ease: [0.68, -0.25, 0.265, 1.25],
	};

	return (
		<section className="bg-black mt-24 py-24 relative overflow-hidden">
			<div className="absolute inset-0 bg-gradient-to-r from-secondary to-primary skew-y-3 transform origin-top-right" />

			<div className="relative">
				<motion.div
					className="max-w-3xl mx-auto text-center text-white"
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={bounceTransition}
				>
					<h2 className="text-4xl md:text-6xl font-bold mb-8">
						Need Help Choosing?
					</h2>
					<p className="text-xl mb-12 text-white/90">
						Our experts are here to help you find the perfect shade for your
						space.
					</p>
					<motion.button
						className="inline-flex items-center px-8 py-4 bg-white text-primary rounded-xl font-semibold shadow-lg group"
						whileHover={{ scale: 1.05 }}
						whileTap={{ scale: 0.95 }}
					>
						<Link
							to="/contact"
							className="flex items-center gap-2 color-primary"
						>
							<span>Contact Support</span>
						</Link>
						<motion.span
							className="ml-2 opacity-0 group-hover:opacity-100 transition-opacity"
							animate={{ x: [0, 5, 0] }}
							transition={{ duration: 1, repeat: Infinity }}
						>
							→
						</motion.span>
					</motion.button>
				</motion.div>
			</div>
		</section>
	);
};

export default ContactBlock;
